import ThisModule from "./Collapsible";

export default ThisModule;
